import Pagination from '@api/entities/Pagination';
class BricksOnSale {
    pagination;
    list;
    constructor(data) {
        this.pagination = new Pagination({ pagination: data, count: data.totalItems });
        this.list = data.items;
    }
}
export default BricksOnSale;
